

// Wrap sections in a wrapper.
const childSections = document.querySelectorAll(".image-with-text-section:has(.mouse-slide)");
if(childSections.length){
	childSections.forEach((e) => {
		e.classList.add("swiper-slide");
	});
	
	var wrapper = document.createElement('div');
	wrapper.classList.add("ms-wrapper");
	wrapper.classList.add("swiper");
	wrapper.innerHTML = '<div class="swiper-wrapper"></div><div class="swiper-button-next"></div><div class="swiper-button-prev"></div>';
    childSections.item(0).parentNode.insertBefore(wrapper, childSections.item(0));
	
	for ( var i=0; i< childSections.length; i++){
		wrapper.querySelector('.swiper-wrapper').appendChild(childSections.item(i));
	}

    var swiper = new Swiper(".ms-wrapper", {
      effect: "fade",
      slidesPerView: 1,
      spaceBetween: 0,
  	  fadeEffect: {
          crossFade: true
      },
      mousewheel: {
          releaseOnEdges: true,
      },
      keyboard: {
        enabled: true,
      },
      navigation: {
         nextEl: ".swiper-button-next",
         prevEl: ".swiper-button-prev",
      },
    });
}
